import { getUrl, requests } from "../../globals/requests";
import {
  LOADING_GET_LOANS,
  GET_LOANS,
  ERROR_GETTING_LOANS,
  SET_LOAN,
} from "../types";

export const getLoans = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: LOADING_GET_LOANS,
        payload: true,
      });
      dispatch({
        type: ERROR_GETTING_LOANS,
        payload: false,
      });
      const url = getUrl("loans");
      const response = await requests.getWithAuth(url);
      dispatch({
        type: GET_LOANS,
        payload: response.data,
      });

      dispatch({
        type: LOADING_GET_LOANS,
        payload: false,
      });
      return response.data;
    } catch (e) {
      dispatch({
        type: LOADING_GET_LOANS,
        payload: false,
      });
      dispatch({
        type: ERROR_GETTING_LOANS,
        payload: true,
      });
      throw e;
    }
  };
};
export const getLoan = (id) => {
  return async (dispatch) => {
    try {
      const url = `${getUrl("loans")}/${id}`;
      const response = await requests.getWithAuth(url);
      dispatch({
        type: SET_LOAN,
        payload: response.data,
      });
      return response.data;
    } catch (e) {
      throw e;
    }
  };
};

export const setLoan = (loan) => {
  return {
    type: SET_LOAN,
    payload: loan,
  };
};

export const updateLoanStatus = (id, params) => {
  return async (dispatch) => {
    try {
      const url = `${getUrl("loans")}/${id}/status`;
      const response = await requests.putWithAuth(url, params);
      dispatch({
        type: SET_LOAN,
        payload: response.data,
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  };
};

export const approveLoan = (id, body) => {
  return async (dispatch) => {
    try {
      const url = `${getUrl("loans")}/${id}/approve`;
      const response = await requests.putWithAuth(url, body);
      dispatch({
        type: SET_LOAN,
        payload: response.data,
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  };
};
export const denyLoan = (id) => {
  return async (dispatch) => {
    try {
      const url = `${getUrl("loans")}/${id}/deny`;
      const response = await requests.putWithAuth(url);
      dispatch({
        type: SET_LOAN,
        payload: response.data,
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  };
};
